import React, { useState, useContext } from 'react';
import { MdModeEdit, MdDelete } from 'react-icons/md';
import { IoMdAdd } from 'react-icons/io';
import { useTranslation } from 'react-i18next';

import * as S from './styles';
import { UseTranslationProps } from 'types/UseTranslationProps';
import AccordionWithTitle from 'components/AccordionWithTitle';
import { ItemFromElementMenuProps } from 'types/ElementMenuProps';
import NoImage from 'components/NoImage';
import ItensMenuContext from 'context/ItensMenuContext';
import SystemNotifyContext from 'context/SystemNotifyContext';
import { deleteItemFromBd } from './reqs';
import { getElementsId } from 'pages/ItemMenuSelected/reqs';

interface ItemFromItemMenuProps {
	item: ItemFromElementMenuProps;
	title: string;
	slug: string;
}

export default function ItemFromItemMenu({
	item,
	title,
	slug
}: ItemFromItemMenuProps) {
	const { t }: UseTranslationProps = useTranslation();
	const [isOpen, setIsOpen] = useState(false);
	const {
		setIsFormOpen,
		setItensFromElement,
		setItemFromElementToEdit,
		setIdFatherElement,
		setIsLoad
	} = useContext(ItensMenuContext);
	const { handleNotify } = useContext(SystemNotifyContext);

	async function handleDeleteItem(id: string) {
		const resp = await deleteItemFromBd(id, handleNotify);

		if (resp) {
			setIsLoad(true);
			const resp = await getElementsId(slug, handleNotify);
			setIsLoad(false);

			if (resp.isSuccess) setItensFromElement(resp.data);
			setIsFormOpen(false);
		}
	}

	function handleEdit(itemToEdit: ItemFromElementMenuProps) {
		setIsFormOpen(true);
		setItemFromElementToEdit(itemToEdit);
	}

	function handleAddNewItemChildSomeone(fatherItem: ItemFromElementMenuProps) {
		setIsFormOpen(true);
		setIdFatherElement(fatherItem.id);
	}

	return (
		<AccordionWithTitle
			key={item.id}
			open={isOpen}
			setOpen={setIsOpen}
			title={title}
		>
			<S.container>
				<S.item key={item.id}>
					<S.infos>
						<p>
							<b>{t('itemFromItemMenu.active')}: </b>
							{t(item?.active ? 'itemFromItemMenu.yes' : 'itemFromItemMenu.no')}
						</p>
						<p>
							<b>{t('itemFromItemMenu.redirectBy')}: </b>
							{item?.redirect_type || t('itemFromItemMenu.notSettings')}
						</p>
						<p>
							<b>{t('itemFromItemMenu.redirectValue')}: </b>
							{item?.redirect_value || t('itemFromItemMenu.notSettings')}
						</p>
						<p>
							<b>{t('itemFromItemMenu.redirectValueBanner')}: </b>
							{item?.banner_redirect_value || t('itemFromItemMenu.notSettings')}
						</p>

						{item?.highlighted_color !== null && (
							<S.colorContainer>
								<p>
									<b>{t('Cor')}: </b>
								</p>
								<S.ballColor $color={item?.highlighted_color || '#000'} />
							</S.colorContainer>
						)}

						<S.btnsItem>
							<IoMdAdd onClick={() => handleAddNewItemChildSomeone(item)} />
							<MdModeEdit onClick={() => handleEdit(item)} />
							<MdDelete onClick={() => handleDeleteItem(item.id)} />
						</S.btnsItem>
					</S.infos>

					<S.imgs>
						{item?.file_left &&
						item?.file_left !== null &&
						item?.file_left?.relativePath !== '' ? (
							<img
								src={
									item?.file_left?.relativePath
										? `${process.env.REACT_APP_PATH_SERVER_IMGS}${item?.file_left?.relativePath}`
										: ''
								}
								alt={item?.file_left?.name || ''}
							/>
						) : (
							<NoImage text="itemFromItemMenu.noImageRigth" />
						)}

						{item?.banner_file &&
						item?.banner_file !== null &&
						item?.banner_file?.relativePath !== '' ? (
							<img
								src={
									item?.banner_file?.relativePath
										? `${process.env.REACT_APP_PATH_SERVER_IMGS}${item?.banner_file?.relativePath}`
										: ''
								}
								alt={item?.banner_file?.name || ''}
							/>
						) : (
							<NoImage text="itemFromItemMenu.noBanner" />
						)}

						{item?.file_right &&
						item?.file_right !== null &&
						item?.file_right?.relativePath !== '' ? (
							<img
								src={
									item?.file_right?.relativePath
										? `${process.env.REACT_APP_PATH_SERVER_IMGS}${item?.file_right?.relativePath}`
										: ''
								}
								alt={item?.file_right?.name || ''}
							/>
						) : (
							<NoImage text="itemFromItemMenu.noImageLeft" />
						)}
					</S.imgs>
				</S.item>

				{item?.children?.length > 0 &&
					item.children.map((itemChild) => (
						<ItemFromItemMenu
							slug={slug}
							key={itemChild.id}
							item={itemChild}
							title={`${t('itemFromItemMenu.child')}: ${item?.name || 'Erro nome child'} | ${t('itemFromItemMenu.name')}: ${itemChild?.name || 'Erro nome'}  `}
						/>
					))}
			</S.container>
		</AccordionWithTitle>
	);
}
